export default __webpack_public_path__ + "static/media/suitenupcias_8.ccb4ecb1.jpg";